import Yup from 'utils/yup';
import { ConfigurationFormFieldValues } from './types';

export const CONFIGURATION_FORM_VALUES: ConfigurationFormFieldValues = {
  technique: '',
  groundTruth: '',
  label: '',
  expressionPattern: '',
  expressionRegex: ''
};

export const CONFIG_VALIDATION_SCHEMA = Yup.object().shape({
  technique: Yup.string().required('Technique is required')
});

export const LOOkUP_VALIDATION_SCHEMA = Yup.object().shape({
  lookupFilePath: Yup.string().required('File is required'),
  sheetTypeName: Yup.string().required('Sheet Type is required'),
  sheetDisplayAsColumn: Yup.string().required('Display Value Column is required'),
  sheetPatternColumn: Yup.string()
    .required('Document Pattern Column is required')
    .test('different-values', 'Display Value Column and Document Pattern Column cannot be the same', function (value) {
      const { sheetDisplayAsColumn } = this.parent;
      return value !== sheetDisplayAsColumn;
    })
});

export const MULTILINE_FIELDS = ['fieldDescription'];
export const SELECT_FIELDS = ['sheetTypeName', 'sheetDisplayAsColumn', 'sheetPatternColumn'];
export const LOOKUP_FIELDS = [
  'sheetTypeName',
  'sheetDisplayAsColumn',
  'sheetPatternColumn',
  'documentPattern',
  'displayValue',
  'lookupFilePath'
];
export const LOOKUP_FIELDS_On_NOfileUplaod = ['lookupFilePath', 'sheetTypeName', 'sheetPatternColumn', 'sheetDisplayAsColumn'];
export const DISABLE_FIELDS = ['expressionRegex', 'isLookUpExcel', 'documentPattern', 'displayValue'];
export const ENABLE_RUBBERBAND = ['label', 'sectionFooter', 'sectionHeader', 'documentPattern', 'columnLabelName', 'columnName', 'roi'];
export const CHECKBOX_FIELDS = ['checkboxOptionValueTildeSeparated'];
export const lookUpValidComponentIDs = [13, 27, 28];
export const checkBoxComponentIDs = [10, 21,67];
export const TABLE_TECHNIQUE_ID = 25;
export const SearchBardCodeComponentID = 18;

export const OPTIONAL_ANCHORS_DEFAULT_OPTION_ID = 1;
export const MULTI_SELECT_CHECKBOX_TYPE = 'MultiSelectCheckBox';
export const MIN_REQUIRED_COLUMNS = 2;
export const SIGNATURE_FIELDS = [11, 22, 52, 59, 60, 61];
export const CHECKBOX_FIELD_IDS = [21];
export const DO_NOT_SHOW_SELECT_TECHNIQUES = [...SIGNATURE_FIELDS, ...checkBoxComponentIDs];
export const LOOKUP_TAGGING_FIELDS = [10366, 10367];
export const ENABLE_RUBBERBAND_ASSURANCE = ['sectionFooter', 'sectionHeader'];
export const POSITION_BASED_TAGGING_ROI_DISABLED_COMPONENTS = [20, 21, 22, 66];
export const LABEL_BASED_TECHNIQUE_IDS = [8, 9, 11, 26, 63, 64];
